import { useScrollRef } from '@/utils/sharedHooks'
import { Card, Heading, HeadingVariants } from '@/ui'

import { PlaidLinkContextProvider } from './plaid/LinkContext'
import { PlaidErrorDialog } from './plaid/ErrorDialog'
import { NewInstitutionButton } from './NewInstitutionButton'
import { InstitutionList } from './InstitutionList'
import { DuplicateInstitutionDialog } from './DuplicateInstitutionDialog'
import { NoMoreStatementsCard } from './NoMoreStatementsCard'
import { useBooleanFlagValue } from '@openfeature/react-sdk'
import { FEATURE_FLAG_KEYS } from '@/features/open-feature'

export const ConnectedFinancialInstitutionsCard = () => {
  const { scrollRef } = useScrollRef()

  const shouldEnableAutoReconCUBK2 = useBooleanFlagValue(
    FEATURE_FLAG_KEYS.enableAutoreconCUBK2,
    false
  )

  return (
    <PlaidLinkContextProvider>
      <Card>
        <span ref={scrollRef} />

        <div className="flex flex-row justify-between mb-4">
          <Heading variant={HeadingVariants.H2} className="inline-flex">
            Connected Financial Institutions
          </Heading>

          <NewInstitutionButton />
        </div>

        {!shouldEnableAutoReconCUBK2 && <NoMoreStatementsCard />}
        <InstitutionList />
        <DuplicateInstitutionDialog />
        <PlaidErrorDialog />
      </Card>
    </PlaidLinkContextProvider>
  )
}
